import { apiSlice } from '../apiSlice';
import { SuccessResponse } from '../DTO/common.interface';
import {
	AppendixFiveDTO,
	AppendixFiveRequest,
	AppendixFiveSaveDTO,
} from '../DTO/forms-management/appendix5';

export const appendix5 = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getAppendix5List: builder.query<SuccessResponse<AppendixFiveDTO[]>, string>(
			{
				query: (id) => ({
					url: `/web/form/appendix-five/list/${id}`,
					method: 'GET',
				}),
				providesTags: ['Appendix5List'],
			}
		),
		deleteAppendix5: builder.mutation<SuccessResponse<any>, string>({
			query: (id) => ({
				url: `/web/form/appendix-five/${id}`,
				method: 'DELETE',
			}),

			invalidatesTags: ['Appendix5List'],
		}),
		Appendix5HasDraft: builder.query<SuccessResponse<any>, string>({
			query: (id) => ({
				url: `/web/form/appendix-five/has-draft/${id}`,
				method: 'GET',
			}),
			keepUnusedDataFor: 0,
		}),
		getAppendix5Draft: builder.query<
			SuccessResponse<AppendixFiveSaveDTO>,
			{ id: string; type: string }
		>({
			query: ({ id, type }) => ({
				url: `/web/form/appendix-five/to-create/${id}/${type}`,
				method: 'GET',
			}),
		}),
		continueAppendix5Draft: builder.mutation<
			SuccessResponse<AppendixFiveSaveDTO>,
			{ id: string; type: number }
		>({
			query: ({ id, type }) => ({
				url: `/web/form/appendix-five/to-create/${id}/${type}`,
				method: 'GET',
			}),
		}),
		editAppendix5: builder.mutation<SuccessResponse<any>, AppendixFiveRequest>({
			query: (body) => ({
				url: `/web/form/appendix-five/${body.id}`,
				method: 'PUT',
				body,
			}),
		}),
		createAppendix5: builder.mutation<
			SuccessResponse<any>,
			AppendixFiveRequest
		>({
			query: (body) => ({
				url: `/web/form/appendix-five`,
				method: 'POST',
				body,
			}),
		}),
		getAppendix5Detail: builder.query<SuccessResponse<AppendixFiveDTO>, string>(
			{
				query: (id) => ({
					url: `/web/form/appendix-five/${id}`,
					method: 'GET',
				}),
			}
		),
	}),
});

export const {
	useGetAppendix5ListQuery,
	useDeleteAppendix5Mutation,
	useAppendix5HasDraftQuery,
	useGetAppendix5DraftQuery,
	useContinueAppendix5DraftMutation,
	useEditAppendix5Mutation,
	useCreateAppendix5Mutation,
	useGetAppendix5DetailQuery,
} = appendix5;
